<template>
  <el-dialog :title="$t('integralSetting.editTitle')" :visible.sync="dialogVisible" width="70%" @close="handleClose">
    <el-form ref="form" :model="editIntegralSettingInfo" label-width="120px" label-position="left">
      <el-form-item :label="$t('integralSetting.money')" prop="money" :rules="[
        { required: true, message: $t('integralSetting.moneyRequired') },
        { max: 12, message: $t('integralSetting.moneyMaxLength') }
      ]">
        <el-input v-model="editIntegralSettingInfo.money" :placeholder="$t('integralSetting.moneyPlaceholder')"
          style="width: 100%">
          <template slot="prepend">{{ $t('integralSetting.onePointEquals') }}</template>
          <template slot="append">{{ $t('integralSetting.yuan') }}</template>
        </el-input>
      </el-form-item>

      <el-form-item :label="$t('integralSetting.shopping')" prop="goodsFlag" :rules="[
        { required: true, message: $t('integralSetting.shoppingRequired') }
      ]">
        <el-select v-model="editIntegralSettingInfo.goodsFlag" :placeholder="$t('integralSetting.shoppingPlaceholder')"
          style="width: 100%">
          <el-option :label="$t('common.yes')" value="Y" />
          <el-option :label="$t('common.no')" value="N" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('integralSetting.payment')" prop="feeFlag" :rules="[
        { required: true, message: $t('integralSetting.paymentRequired') }
      ]">
        <el-select v-model="editIntegralSettingInfo.feeFlag" :placeholder="$t('integralSetting.paymentPlaceholder')"
          style="width: 100%">
          <el-option :label="$t('common.yes')" value="Y" />
          <el-option :label="$t('common.no')" value="N" />
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('integralSetting.usage')" prop="remark" :rules="[
        { required: true, message: $t('integralSetting.usageRequired') },
        { max: 512, message: $t('integralSetting.usageMaxLength') }
      ]">
        <el-input v-model="editIntegralSettingInfo.remark" type="textarea"
          :placeholder="$t('integralSetting.usagePlaceholder')" :rows="4" style="width: 100%" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">
        {{ $t('common.cancel') }}
      </el-button>
      <el-button type="primary" @click="handleSubmit">
        {{ $t('common.save') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { updateIntegralSetting } from '@/api/admin/integralSetting/integralSettingApi'

export default {
  name: 'EditIntegralSetting',
  data() {
    return {
      dialogVisible: false,
      editIntegralSettingInfo: {
        settingId: '',
        money: '',
        remark: '',
        goodsFlag: '',
        feeFlag: ''
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.editIntegralSettingInfo = { ...row }
        this.$refs.form && this.$refs.form.clearValidate()
      })
    },
    handleClose() {
      this.$refs.form.resetFields()
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        await updateIntegralSetting(this.editIntegralSettingInfo)
        this.$message.success(this.$t('common.saveSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        this.$message.error(error)
        console.error('保存失败:', error)
      }
    }
  }
}
</script>